// extracted by mini-css-extract-plugin
export default {"timelineCard":"TimelineCard_timelineCard__eF7Yf","timelineCardImg":"TimelineCard_timelineCardImg__jn1ad"};